import { getUrlInfo } from './utils'
export default {
    namespaced: true,
    state: {
        urlInfo: {},
        schoolType: ''
    },
    mutations: {
        // 设置url参数
        SET_URL_INFO: (state, data) => {
            state.urlInfo = data
        },
        // 设置驾校类型 区分是深港的 还是别的
        SET_SCHOOL_TYPE: (state, data) => {
            sessionStorage.setItem('contractWxAppId', data)
            let type = ''
            if (data === 'wx2ba04a0746590bdf') {
                type = 'sg'
            } else {
                type = 'other'
            }
            state.schoolType = type
        }
    },
    actions: {
        setUrlInfo: ({ commit }, params) => {
            commit('SET_URL_INFO', getUrlInfo(params.appid))
            commit('SET_SCHOOL_TYPE', params.appid)
        }
    },
    getters: {
        urlInfo: (state) => {
            return state.urlInfo
        },
        schoolType: (state) => {
            return state.schoolType
        },
    },
}